module.exports = __webpack_public_path__ + "media/images/Icône train-4955aab4aa328cef0af19cf115b22548.svg";